import React from "react";

export type NoteRowType = {
  title: string;
  added: Date;
  note: string;
  runSheetTime?: string;
};

const NoteRow = ({ title, added, note, runSheetTime }: NoteRowType) => {
  const noteAddedDate = new Date(added);
  const addedDate = noteAddedDate.toLocaleString(window.locale, {
    dateStyle: "short"
  });
  const addedTime = noteAddedDate
    .toLocaleTimeString(window.locale, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    })
    .toUpperCase();

  return (
    <div className="w-full mb-0.5 bg-muted rounded p-3">
      <div className="flex items-baseline gap-2">
        <div className="font-semibold">{title}</div>
        <div className="ml-auto pr-3">{addedTime}</div>
        <div className="font-semibold">{addedDate}</div>
      </div>
      <div className="mt-2 flex gap-3">
        {runSheetTime && (
          <div className="font-semibold pr-3">{runSheetTime}</div>
        )}
        <div className="whitespace-pre-wrap break-words flex-1 min-w-0">
          {note}
        </div>
      </div>
    </div>
  );
};

export default React.memo<NoteRowType>(NoteRow);
